import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import {
  defaultLanguage,
  languageStorageKey,
  resources,
  SupportedLanguage,
  supportedLanguages,
} from "./resources";

const isSupportedLanguage = (value: string): value is SupportedLanguage =>
  supportedLanguages.includes(value as SupportedLanguage);

const normalizeLanguage = (value: string | null | undefined): SupportedLanguage | null => {
  if (!value) {
    return null;
  }

  const languageCode = value.split("-")[0]?.toLowerCase();
  if (!languageCode || !isSupportedLanguage(languageCode)) {
    return null;
  }

  return languageCode;
};

const getStoredLanguage = (): SupportedLanguage | null => {
  try {
    return normalizeLanguage(window.localStorage.getItem(languageStorageKey));
  } catch {
    return null;
  }
};

const getNavigatorLanguage = (): SupportedLanguage | null =>
  normalizeLanguage(window.navigator.language);

const initialLanguage = getStoredLanguage() ?? getNavigatorLanguage() ?? defaultLanguage;

void i18n.use(initReactI18next).init({
  resources,
  lng: initialLanguage,
  fallbackLng: defaultLanguage,
  supportedLngs: supportedLanguages,
  interpolation: {
    escapeValue: false,
  },
});

export const changeLanguage = async (language: SupportedLanguage): Promise<void> => {
  try {
    window.localStorage.setItem(languageStorageKey, language);
  } catch {
    // localStorage が利用できない環境でも、画面上の言語切替は継続する
  }

  await i18n.changeLanguage(language);
};

export default i18n;
